export default {
  type: "black-list-users",
  excerpt: "",
  relationshipNames: ["organization", "user"],
  organization: {
    type: "organizations",
    id: null,
  },
  user: {
    type: "users",
    id: null,
  }
};
